import { render } from "./ChoiceReportCategory.vue?vue&type=template&id=19a49ad2&scoped=true&ts=true"
import script from "./ChoiceReportCategory.vue?vue&type=script&lang=ts"
export * from "./ChoiceReportCategory.vue?vue&type=script&lang=ts"

import "./ChoiceReportCategory.vue?vue&type=style&index=0&id=19a49ad2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a49ad2"]])

export default __exports__